import React from "react"

const TopBlurCircle = () => {
  return (
    <svg
      style={{ position: "absolute", top: 0, left: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="127"
      height="135"
      viewBox="0 0 127 135"
      fill="none"
    >
      <g opacity="0.2" filter="url(#filter0_f_40008171_388)">
        <circle cx="20.5" cy="44.5" r="56.5" fill="#6959C7" />
      </g>
      <defs>
        <filter
          id="filter0_f_40008171_388"
          x="-86"
          y="-62"
          width="213"
          height="213"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="25"
            result="effect1_foregroundBlur_40008171_388"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default TopBlurCircle
